import React, { useState, useCallback } from 'react';
import { Auth } from 'aws-amplify';
import Loader from '@ts/ui/Loader';
import { forms } from '../data';
import * as S from '../styles';

function ResetPasswordForm({ onSendForm, updateUserEmail, userEmail, setActiveForm }) {
    const [error, updateError] = useState('');
    const [isLoading, updateIsLoading] = useState(false);

    const validateForm = useCallback(() => {
        if (!userEmail) {
            updateError('Type your email please');
            return false;
        }
        updateError('');
        return true;
    }, [userEmail, updateError]);

    const onSubmit = useCallback(
        (event) => {
            event.preventDefault();
            if (validateForm() && !isLoading) {
                updateIsLoading(true);
                Auth.forgotPassword(userEmail)
                    .then(() => {
                        updateIsLoading(false);
                        onSendForm(true);
                    })
                    .catch((err) => {
                        updateIsLoading(false);
                        updateError(err.message);
                    });
            }
        },
        [userEmail, validateForm, updateIsLoading, updateError, onSendForm, isLoading]
    );

    return (
        <S.Form>
            <S.Title>Forgot your password?</S.Title>
            <S.InnerTitle>
                Enter your email below and we will send a message to reset your password
            </S.InnerTitle>
            {error && <S.Error>{error}</S.Error>}
            <S.Label htmlFor="email">Email</S.Label>
            <S.Input
                type="email"
                value={userEmail}
                name="email"
                onChange={updateUserEmail}
                placeholder="Email"
            />
            <S.SubmitButton onClick={onSubmit} disabled={isLoading}>
                {isLoading ? (
                    <S.LoaderWrap>
                        <Loader size="massive" />
                    </S.LoaderWrap>
                ) : (
                    'Reset my password'
                )}
            </S.SubmitButton>
            <S.TextWrapper>
                <S.Text>Back to</S.Text>
                <S.BlueButton onClick={() => setActiveForm(forms.signin)}>sign in</S.BlueButton>
            </S.TextWrapper>
        </S.Form>
    );
}

export default ResetPasswordForm;
export { ResetPasswordForm };
